import { useDispatch, useSelector } from "react-redux";
import { selectEditMode } from "../../slices/editMode/editModeSlice";
import { Button } from "semantic-ui-react";
import { changeTabFocus } from "../../slices/tabPane/tabPaneSlice";

const ViewEditJSONButton = () => {
    const editMode = useSelector(state => selectEditMode(state));
    const dispatch = useDispatch();
    return <Button className="formButton navigationButton"
        style={{ color: "#000000", width: "97%", margin: "0px" }}
        content={editMode ? "Edit JSON" : "View JSON"}
        onClick={() => { dispatch(changeTabFocus("JSON View")); }} />;
};

export default ViewEditJSONButton;